import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3afac61c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "inspectionInfo-container" }
const _hoisted_2 = { class: "inspection-list" }
const _hoisted_3 = { class: "stepLeft" }
const _hoisted_4 = { class: "stepIcon" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  style: {"border-left":"solid 1px #969799"},
  class: "stepLine"
}
const _hoisted_7 = { class: "stepRight" }
const _hoisted_8 = { class: "stepTitle" }
const _hoisted_9 = { class: "stepText" }
const _hoisted_10 = { class: "button" }
const _hoisted_11 = { class: "scan" }
const _hoisted_12 = ["src"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "xunjian" }, "扫码巡检", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      "left-arrow": "",
      title: _ctx.$route.meta.title,
      placeholder: "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.initData, (li, i) => {
        return (_openBlock(), _createElementBlock("div", {
          key: i,
          style: _normalizeStyle({ color: li.done ? '#1E2124' : '#B0B2C3' }),
          class: "step"
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (li.done)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "step-image",
                    src: require('@/assets/anquanxunjian/steptip.png')
                  }, null, 8, _hoisted_5))
                : (_openBlock(), _createBlock(_component_van_icon, {
                    key: 1,
                    name: "circle"
                  }))
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_6, null, 512), [
              [_vShow, _ctx.initData.length - 1 !== i]
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(li.name), 1),
            _createElementVNode("div", _hoisted_9, _toDisplayString(li.remark), 1)
          ])
        ], 4))
      }), 128)),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_van_button, {
          block: "",
          type: "primary",
          onClick: _ctx.scan
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_11, [
              _createElementVNode("img", {
                src: require('@/assets/inspection/scan.png')
              }, null, 8, _hoisted_12)
            ]),
            _hoisted_13
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ])
  ]))
}